import React from 'react';

export default function SubHeading({ text = '', children, styles }) {
  return (
    <div className={' mb-4 font-light text-gray-700 lg:mb-8 md:text-xl text-center ' + styles}>
      {text} {children}
    </div>
  );
}
